import { useShallowRouter } from '@components/Hooks/useRouter';
import { useTemplateGalleryFilters } from '@components/Hooks/useTemplateGalleryFilters/useTemplateGalleryFilters';
import { updateQueryParams } from '@utils/route';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';
import { TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { FC } from 'react';

export const resetButtonDataHooks = {
  button: 'reset-button',
};

const ResetButton: FC = () => {
  const { t } = useTranslation();
  const { navigate, router } = useShallowRouter();
  const { hasActiveFilters } = useTemplateGalleryFilters();
  const { logBiClick } = useTemplatesBi({ is_mobile: false });

  const isDisabled = !hasActiveFilters;

  const clearFilters = () => {
    logBiClick({
      click_type: 'Reset filters',
    });
    navigate(
      updateQueryParams(
        {},
        router,
        {},
        {
          search: true,
        },
      ),
    );
  };

  return (
    <TextButton
      size="small"
      disabled={isDisabled}
      onClick={clearFilters}
      dataHook={resetButtonDataHooks.button}
      aria-label={t('marketplace.template-page.filter-panel.reset')}
    >
      {t('marketplace.template-page.filter-panel.reset')}
    </TextButton>
  );
};

export default ResetButton;
